var ReactQuery = require("react-query");

exports._useQuery = (keyStr) => (cbFn) => () => {
  var result = ReactQuery.useQuery({ queryKey: [keyStr], queryFn: cbFn });

  return result;
};

exports._useQueryClient = () => ReactQuery.useQueryClient;
